import React, { useState } from 'react'
import './style.css'

export default function Position({element, x, y, height, width, onChangePosition, showHeight, showWidth, showRotate, rotate}) {
  const [open, setOpen] = useState(false)

  return (
    <div tabIndex={0} onBlur={(e) => {
      if (e.currentTarget.contains(e.relatedTarget)) {
        return
      }
      setOpen(false)
    }}>
        <div className='Position' onClick={()=>setOpen(true)}>{element}
            <div className={open ? 'Position_Con Position_Con_Open' : 'Position_Con'}>
                <div className='Position_Con1'>
                  <div className='Position_Input_Con'>
                    <p>X POSITION</p>
                    <input type='number' value={x || 0} onChange={(e)=>onChangePosition(e?.target?.value * 1, y)}/>
                  </div>
                  <div className='Position_Input_Con'>
                    <p>Y POSITION</p>
                    <input type='number' value={y || 0} onChange={(e)=>onChangePosition(x, e?.target?.value * 1)}/>
                  </div>
                  {showHeight?
                  <div className='Position_Input_Con'>
                    <p>HEIGHT</p>
                    <input type='number' value={height || 0} onChange={(e)=>onChangePosition()}/>
                  </div>
                  : null}
                  {showWidth?
                  <div className='Position_Input_Con'>
                    <p>WIDTH</p>
                    <input type='number' value={width || 0} onChange={(e)=>onChangePosition()}/>
                  </div>
                  : null}
                  {showRotate?
                  <div className='Position_Input_Con'>
                    <p>ROTATION</p>
                    <input type='number' value={rotate || 0} onChange={(e)=>onChangePosition()}/>
                  </div>
                  : null}
                </div>
            </div>
        </div>
    </div>
  )
}
